import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { Config, Environments } from "src/app/config";
import { WidgetsQuestionModel } from "src/app/models/widgets/widgets-question.model";
import { QuestionLibraryService } from "src/app/services/widgets/question-library.service";
import { QuestionTypeModel } from "../../models/api/questionType.model";
import { CloneService } from "../clone/clone.service";
import { WidgetsResequenceService } from "../widgets/widgets-resequence.service";
import { WidgetsService } from "../widgets/widgets.service";
import { BehaviorSubject, switchMap } from 'rxjs';
import { WidgetsFormModel } from "src/app/models/widgets/widgets-form.model";
import { PostQuestionModel } from "src/app/models/widgets/post-question.model";

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  constructor(
    private http: HttpClient,
    private widgetsCloneService: CloneService,
    private widgetsResequenceService: WidgetsResequenceService,
    private widgetsService:WidgetsService
    ) {
    // Empty
  }

  private questionaLibrary = new BehaviorSubject(null);
  questionaLibrary$ = this.questionaLibrary.asObservable(); 

  private questionaLibraryLength = new BehaviorSubject(null);
  questionaLibraryLength$ = this.questionaLibraryLength.asObservable(); 

  private questionResult = new BehaviorSubject(null);
  questionResult$ = this.questionResult.asObservable(); 

  private questionCount = new BehaviorSubject(null);
  questionCount$ = this.questionCount.asObservable();

  emitDBids(dbIds) {
    this.questionaLibrary.next(dbIds);
  }

  emitQuestionLength(length){
    this.questionaLibraryLength.next(length);
  }

  emitQuestionResult(length){
    this.questionResult.next(length);
  }

  emitquestionCount(length){
    this.questionCount.next(length)
  }
  /**
   * API call to fetch One Question Based on ID
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  getQuestion(Id: any) {
    if(Id)
    {
      // const url = environment.endpoints.getQuestion;
      let baseurl = '';
      if (Config && Config.app) {
          baseurl = Config.projectApiUrl;
          baseurl = `${baseurl}/Questions`;
      }
      return this.http.get<WidgetsQuestionModel[]>(`${baseurl}/?questionId=${Id}`);
    }
  }

  /**
   * API call to fetch all Questios/ Search Questions Based on Tag name
   * @dbIdArray it is a array of ids of recent canvase questions
   * this method will fetch all remote questions except ids of recent canvase questions
   */
  dbIdArray = [];
  getQuestions(questionName: string = "", dbIdArray?, offset?, limit?) {
    if(dbIdArray){
      this.dbIdArray = dbIdArray
    }    
    // const url = environment.endpoints.getAllQuestion;
    let baseurl = '';
    if (Config && Config.app) {
        baseurl = Config.projectApiUrl;
        baseurl = `${baseurl}/Questions/SearchQuestions`;
    }
   
    let payload = { "SkipQuestionIds": this.dbIdArray, "QuestionName": questionName, "Offset": offset, "Limit": limit }
    return this.http.post<WidgetsQuestionModel[]>(`${baseurl}`, payload).pipe(
      map((questions:any)=> { 
        this.emitquestionCount(questions.QuestionTotalCount);
        return  questions.QuestionInfos
      }));
  }




  /**
   * it will get the questions ids of current canvas qeuestions, and emit the value in observable
   * **/ 
  updateQuestionLibraray(){
    let layout_ = this.widgetsService.getLayoutRoot(),
        root = new WidgetsFormModel(),
        dbIdArray = [];

    this.widgetsCloneService.cloneFromJS(layout_, root, false, false, undefined );
    this.widgetsResequenceService.collectDbId(root, dbIdArray).then(() => {      
        this.emitDBids(dbIdArray);              
    })
  }

  /**
   * Save New Question to Data Base
   */
  saveQuestion(questionData)
  {
    let baseurl = '';
    if (Config && Config.app) {
        baseurl = Config.projectApiUrl;
        baseurl = `${baseurl}/Questions`;
    }
    /* eslint-disable @typescript-eslint/ban-types */
    if (!questionData.Id) {
      return this.http.post<Number>(`${baseurl}`, questionData);
    } else {
      return this.http.patch<Number>(`${baseurl}`, questionData);
    }
    /* eslint-enable */
  }

  /**
   * Clones New Question to desire environment Data Base
   */
  cloneQuestionTo(questionId: number, environment: number, token: string)
  {
    let baseurl = '';
    if(Config && Config.app){
      baseurl = Config.app.environmentUrls[Environments[environment]];
    }
    return this.getQuestion(questionId)?.pipe(
      map((data: WidgetsQuestionModel[]) => {
        return new PostQuestionModel(data);
      }),
      switchMap((postQuestionModel: PostQuestionModel) => {

        let newTemplate: WidgetsQuestionModel = JSON.parse(postQuestionModel.questionData.Template);
        newTemplate.dbId = undefined;
        postQuestionModel.questionData.Template = JSON.stringify(newTemplate);

        return this.http.post<Number>(`${baseurl}/Questions`, postQuestionModel.questionData, {headers: {
          'Content-Type': 'application/json',
          identity: Config.user.name,
          Authorization: `Bearer ${token}`
        }});
      })
    );
  }

  /**
   * API call to fetch all Questions/ Search Questions Based on Tag name
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/ban-types
  deleteQuestions(Id: Number, deleteFlag: boolean) {
    // const url = environment.endpoints.getAllQuestion;
    let baseurl = '';
    if (Config && Config.app) {
        baseurl = Config.projectApiUrl;
        baseurl = `${baseurl}/Questions`;
    }
    return this.http.delete(`${baseurl}?Id=${Id}&Delete=${deleteFlag}`);
  }

  /**
   * API call to fetch all Question Types from DB
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/ban-types
  getQuestionTypes() {
    // const url = environment.endpoints.getQuestionTypes;
    let baseurl = '';
    if (Config && Config.app) {
      baseurl = Config.projectApiUrl;
      baseurl = `${baseurl}/Questions/QuestionTypes`;
    }
    return this.http.get<QuestionTypeModel[]>(`${baseurl}`);
  }

  /**
   * Fetch multiple questions by their IDs
   * POST endpoint to retrieve all questions at once
   * @param questionIds Array of question IDs to fetch
   * @returns Observable of array of questions with full details
   */
  getQuestionsByIds(questionIds: number[]) {
    let baseurl = '';
    if (Config && Config.app) {
      baseurl = Config.projectApiUrl;
      baseurl = `${baseurl}/Questions/DownloadQuestions`;
    }
    return this.http.post<any[]>(`${baseurl}`, questionIds);
  }
}
